import React from 'react';

import { createStyles, Theme, withStyles, IconButton } from '@material-ui/core';
import {  Close }from '@material-ui/icons';

import styles from '../../attachments/attachments.module.css';

import WhsOrderAwbReport from '../../whs/whsOrderAwbReport/WhsOrderAwbReport';

import GhaWhPoAwbException from '../../../models/GhaWhPoAwbException';


const materialStyles = (theme: Theme) =>
  createStyles({
    title: {
      paddingLeft: '0px'
    },
    attachmentBody: {
      wrapper: {
        display: 'flex',
        flexDirection: 'column',
      }
    }
  });

interface AwbReportProps {
  classes: any;
  awbNumber: string;
  type: string;
  handleClose: (type: string) => void;
  exceptions: GhaWhPoAwbException;
};



const awbReport = (props: AwbReportProps) => {
  const { classes } = props;
  return (
    <div>
      <div className={ styles.overlay } onClick={() =>  props.handleClose('awbReport') }></div>
      <div className={ styles.attachmentsWrapper }>

        <div className={ styles.attachmentsHeader }>
          <div className={ styles.titleBlk } >
            <div className={ classes.title }>Report Exception </div>
            <div className={ styles.attachmentsHeaderText }>  { props.awbNumber }</div>
          </div>
          <div className={ styles.attachmentsButton } onClick={() =>  props.handleClose('awbReport') } >
            <IconButton aria-label="Close">
              <Close color= "primary"/>
            </IconButton> 
          </div>
        </div>

        <div className={ styles.attachmentsBody } >
          <WhsOrderAwbReport
            awbNumber={ props.awbNumber }
            exceptions={ props.exceptions }
            handleChange={ () => {} }
            handleAttachmentDelete={ () => {} }
            handleAttachmentUpload={ () => {} }
            returnToDriverAwb={() => {} }
            saveExit={ () => {} }
            type={ props.type }
            onlyRead={ true }
          />
        </div>

      </div>
    </div>
  );
}

export default withStyles(materialStyles)(awbReport);